// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var FontAwesomeIcon$ReasonProfile = require("../font-awesome/FontAwesomeIcon.bs.js");

require('./Menu.css')
;

var component = ReasonReact.reducerComponent("Menu");

function make(_children) {
  return {
          debugName: component.debugName,
          reactClassInternal: component.reactClassInternal,
          handedOffState: component.handedOffState,
          willReceiveProps: component.willReceiveProps,
          didMount: component.didMount,
          didUpdate: component.didUpdate,
          willUnmount: component.willUnmount,
          willUpdate: component.willUpdate,
          shouldUpdate: component.shouldUpdate,
          render: (function (self) {
              var match = self.state.isMenuOpen;
              var menuClass = match ? "Menu Menu-is-open" : "Menu";
              var match$1 = self.state.isMenuOpen;
              var iconName = match$1 ? "times" : "bars";
              return React.createElement("div", {
                          className: menuClass
                        }, React.createElement("div", {
                              className: "Menu-toggle"
                            }, React.createElement("button", {
                                  className: "Menu-toggle-button",
                                  onClick: (function (_event) {
                                      return Curry._1(self.send, /* Toggle */0);
                                    })
                                }, ReasonReact.element(undefined, undefined, FontAwesomeIcon$ReasonProfile.make(/* :: */[
                                          "fas",
                                          /* :: */[
                                            iconName,
                                            /* [] */0
                                          ]
                                        ], undefined, "Menu-toggle-icon", undefined, "3x", undefined, /* array */[])))), React.createElement("div", {
                              className: "Menu-links"
                            }, React.createElement("a", {
                                  className: "Menu-link",
                                  href: "https://www.zacharywagner.net"
                                }, "Home"), React.createElement("a", {
                                  className: "Menu-link",
                                  href: "https://www.zacharywagner.net/resume"
                                }, "Resume"), React.createElement("div", {
                                  className: "Menu-link-divider-block"
                                }, React.createElement("div", {
                                      className: "Menu-link-divider"
                                    }, React.createElement("span", undefined, "Other Versions"))), React.createElement("a", {
                                  className: "Menu-link",
                                  href: "https://www.zacharywagner.net"
                                }, "React"), React.createElement("a", {
                                  className: "Menu-link",
                                  href: "https://vue.zacharywagner.net"
                                }, "Vue")));
            }),
          initialState: (function (param) {
              return {
                      isMenuOpen: false
                    };
            }),
          retainedProps: component.retainedProps,
          reducer: (function (action, state) {
              return /* Update */Block.__(0, [{
                          isMenuOpen: !state.isMenuOpen
                        }]);
            }),
          jsElementWrapped: component.jsElementWrapped
        };
}

exports.component = component;
exports.make = make;
/*  Not a pure module */
